// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"381":"31d6cfe0","411":"a6e0b644"}[chunkId] + ".css";
};